import resolveProductUrl from './urls/resolve-product-url';
import { moneyFormat, percentFormat, moneyBetweenFormat, textFormat } from './format';

const calcInitState = (item) => {
  if (!item.mysqlImage || (!item.specific_url && !item.prefix_url)) {
    return { visible: 0 }
  }

  return {
    visible: 1,
    formVisible: item?.form_visible ?? 1,
    name: item.name,
    url: resolveProductUrl(item),
    image: item.mysqlImage,
    rating: item.rating / 20,
    prefix_url: item.prefix_url,
    productType: item.productType,
    points_to_note: item.points_to_note,
  }
};

const productData = (item) => {
  const newState = calcInitState(item);

  switch (item.productType) {
    case 'firm':
      if (item.productSubtypes.includes(2) || item.productSubtypes.includes(3)) {
        newState.content = [
          ["Kwota", moneyFormat(item.costs?.amount)],
          ["Okres", textFormat(item.costs?.time, 'miesięcy')],
          ["Rata", moneyFormat(item.costs?.installment)],
          ["RRSO", percentFormat(item.costs?.apr)],
          ["Do oddania", moneyFormat(item.costs?.installment * item.costs?.time)],
        ];
      }
      else {
        newState.content = [
          ['Kwota', moneyFormat(item.costs?.amount)],
          ['Okres', textFormat(item.costs?.time, 'dni')],
          ['Koszt', moneyFormat(item.costs?.cost)],
          ['RRSO', percentFormat(item.costs?.apr)],
          ['Do oddania', moneyFormat(item.costs?.amount + item.costs?.cost)],
        ]
      }
      break
    case 'accounts':
      if (item.productSubtypes.includes(2)) {
        newState.content = [
          ['Oprocentowanie', item.interest.includes('/') ? item.interest.replace('/', ' - ') + '%' : percentFormat(item.interest)],
          ['Prowadzenie rachunku', moneyBetweenFormat(...item.account_fees.split('/'))],
          ['Otwarcie rachunku', moneyFormat(item.opening_fee)],
          ['Przelewy', item.transfer_fees.includes('/') ? item.transfer_fees.replace('/', ' - ') + 'zł' : moneyFormat(item.transfer_fees)],
        ];
      }
      else {
        newState.content = [
          ['Prowadzenie rachunku', moneyBetweenFormat(...item.account_fees.split('/'))],
          ['Bankomaty', moneyBetweenFormat(...item.payment_bank.split('/'))],
          ['Karta', moneyBetweenFormat(...item.card_fees.split('/'))],
          ['Płatności mobilne', item.mobile_payment ? 'tak' : 'nie'],
        ];
      }
      break
    case 'credits':
      newState.content = [
        ['Oprocentowanie', percentFormat(item.percent)],
        ['RRSO', percentFormat(item.aprc)],
        ['Prowizja', item.fee_min < item.fee_max ? `${item.fee_min.toFixed(2)} / ${item.fee_max.toFixed(2)} %` : `${percentFormat(item.fee_max) || '-'}`],
        ['Rata', moneyFormat(item.calculations?.rate)],
        ['Kwota do spłaty', moneyFormat(item.calculations?.cost)],
      ]
      break
    case 'cards':
      if (item.type === 1) {
      newState.content = [
        ['Limit kredytowy', moneyFormat(item.limit_max)],
        ['Okres bezodsetkowy', textFormat(item.free_period, 'dni')],
        ['Opłata za wydanie', moneyFormat(item.card_fee)],
        ['Oprocentowanie', percentFormat(item.interest)],
        ['Operator karty', item.card_operator || '-'],
      ];
    } else {
      newState.content = [
        ['Limit kredytowy', moneyFormat(item.limit_max)],
        ['RRSO', percentFormat(item.aprc)],
        ['Opłata za wydanie', moneyFormat(item.card_fee)],
        ['Operator karty', item.card_operator || '-'],
      ];
    }
      break
    default:
      return newState
  }
  return { ...newState, isLoaded: true }
}


export default productData